document.addEventListener('DOMContentLoaded', () => {
    function initDiamond(section, canvas, isGlobal) {
      if (!canvas) return;

      const atmosphere = (isGlobal ? document.body : section).querySelector('.dm-atmosphere');
      const grain      = (isGlobal ? document.body : section).querySelector('.dm-grain');
      const sticky     = isGlobal ? null : section.querySelector('.dm-balanced-sticky-buy');
      const fixedEls   = [canvas, atmosphere, grain].filter(Boolean);

      const ctx = canvas.getContext('2d');
      let width = 0, height = 0;
      let dpr = Math.min(window.devicePixelRatio || 1, 2);
      let pointer = { x: 0.5, y: 0.42, tx: 0.5, ty: 0.42 };
      let scrollProgress = 0;

      function resize() {
        width = window.innerWidth;
        height = window.innerHeight;
        canvas.width = Math.floor(width * dpr);
        canvas.height = Math.floor(height * dpr);
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }

      function updateScroll() {
        if (isGlobal) { scrollProgress = 0; return; }
        const rect = section.getBoundingClientRect();
        const total = section.offsetHeight - window.innerHeight;
        const passed = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
        scrollProgress = total > 0 ? passed / total : 0;
        section.style.setProperty('--dm-scroll', scrollProgress.toFixed(3));
        if (sticky) sticky.classList.toggle('is-visible', -rect.top > window.innerHeight * 0.65);
        var inView = rect.bottom > 0 && rect.top < window.innerHeight;
        fixedEls.forEach(function (el) { el.style.visibility = inView ? 'visible' : 'hidden'; });
      }

      function drawDiamond(cx, cy, size, alpha, warm) {
        ctx.beginPath();
        ctx.moveTo(cx, cy - size);
        ctx.lineTo(cx + size, cy);
        ctx.lineTo(cx, cy + size);
        ctx.lineTo(cx - size, cy);
        ctx.closePath();
        ctx.strokeStyle = `rgba(${warm ? '185,154,97' : '244,239,230'}, ${alpha})`;
        ctx.lineWidth = warm ? 0.85 : 0.55;
        ctx.stroke();
      }

      const loaderEl = document.getElementById('dm-loader');
      function draw(time) {
        // 性能：开机动画或加载遮罩完全盖住时不绘制（看不见），揭开后照常
        if (document.body.classList.contains('dm-intro-active') || (loaderEl && !loaderEl.classList.contains('is-done'))) { requestAnimationFrame(draw); return; }
        pointer.x += (pointer.tx - pointer.x) * 0.045;
        pointer.y += (pointer.ty - pointer.y) * 0.045;
        ctx.clearRect(0, 0, width, height);

        const t = time * 0.001;
        const cell = Math.max(76, Math.min(118, width / 15));
        const size = cell * 0.42;
        const driftX = Math.sin(t * 0.13) * 20 + (pointer.x - 0.5) * -34;
        const driftY = Math.cos(t * 0.11) * 18 + (pointer.y - 0.5) * -30 + scrollProgress * -42;
        const cols = Math.ceil(width / cell) + 4;
        const rows = Math.ceil(height / cell) + 4;

        ctx.save();
        ctx.translate(driftX - cell * 2, driftY - cell * 2);
        for (let y = 0; y < rows; y += 1) {
          for (let x = 0; x < cols; x += 1) {
            const cx = x * cell + ((y % 2) * cell * 0.5);
            const cy = y * cell * 0.72;
            const dx = (cx + driftX - width * pointer.x) / width;
            const dy = (cy + driftY - height * pointer.y) / height;
            const dist = Math.sqrt(dx * dx + dy * dy);
            const wave = Math.sin(t * 0.55 + x * 0.52 + y * 0.34) * 0.5 + 0.5;
            const pulse = Math.max(0, 1 - dist * 2.1);
            const alpha = 0.035 + wave * 0.045 + pulse * 0.18 + scrollProgress * 0.025;
            drawDiamond(cx, cy, size * (0.94 + wave * 0.08), Math.min(alpha, 0.28), (x + y) % 7 === 0 || pulse > 0.72);
          }
        }
        ctx.restore();

        const gradient = ctx.createRadialGradient(width * pointer.x, height * pointer.y, 0, width * pointer.x, height * pointer.y, Math.max(width, height) * 0.58);
        gradient.addColorStop(0, 'rgba(203,216,210,0.12)');
        gradient.addColorStop(0.42, 'rgba(185,154,97,0.055)');
        gradient.addColorStop(1, 'rgba(7,16,13,0)');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, width, height);
        requestAnimationFrame(draw);
      }

      const pointerTarget = isGlobal ? window : section;
      pointerTarget.addEventListener('pointermove', (event) => {
        pointer.tx = event.clientX / window.innerWidth;
        pointer.ty = event.clientY / window.innerHeight;
      }, { passive: true });

      if (!isGlobal) {
        section.querySelectorAll('.dm-balanced-selector button').forEach((button) => {
          button.addEventListener('click', () => {
            const group = button.parentElement;
            group.querySelectorAll('button').forEach((item) => item.classList.remove('is-active'));
            button.classList.add('is-active');
          });
        });
      }

      window.addEventListener('resize', resize);
      window.addEventListener('scroll', updateScroll, { passive: true });
      resize();
      updateScroll();
      requestAnimationFrame(draw);
    }

    // 首页 section 内的 canvas
    document.querySelectorAll('.dm-balanced-home').forEach((section) => {
      initDiamond(section, section.querySelector('.dm-diamond-canvas'), false);
    });

    // editorial 模板里带 diamond 背景的 section
    document.querySelectorAll('.dm-editorial-bg--diamond').forEach((section) => {
      const cv = section.querySelector(':scope > .dm-diamond-canvas');
      if (cv) initDiamond(section, cv, false);
    });

    // 全局菱格背景(collection / product 等)
    document.querySelectorAll('.dm-global-diamond').forEach((wrap) => {
      const cv = wrap.querySelector(':scope > .dm-diamond-canvas');
      if (cv) initDiamond(wrap, cv, true);
    });

    // 其他页面 body 级别的 canvas
    const globalCanvas = document.querySelector('body > .dm-diamond-canvas');
    if (globalCanvas && !globalCanvas.closest('.dm-balanced-home')) {
      initDiamond(document.body, globalCanvas, true);
    }
  });